import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Select as ChakraSelect, } from "chakra-react-select";
import { FormControl, FormErrorMessage, FormHelperText, FormLabel, InputRightElement, InputGroup, } from "@chakra-ui/react";
import { theme } from "@airhelp/chakra-theme";
import { Info } from "@airhelp/icons";
import { defaultErrorIconColor, defaultHoverErrorIconColor, ErrorIconColor } from "@airhelp/input";
import { useMobileDetect } from "@airhelp/use-mobile-detect";
export const Select = ({ label, placeholder, caption, errorMessage, colorScheme = "error", isDisabled, isInvalid, dataTestId, formControlStyles, handleChange, isSearchable = false, ...props }) => {
    const [errorIconColor, setErrorIconColor] = useState(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger);
    const [isSelectFocused, setIsSelectFocused] = useState(false);
    const isMobile = useMobileDetect();
    const hoveredErrorIconColor = () => isMobile ? defaultErrorIconColor(colorScheme) : defaultHoverErrorIconColor(colorScheme);
    useEffect(() => {
        setErrorIconColor(defaultErrorIconColor(colorScheme));
    }, [colorScheme]);
    const onFocus = () => {
        setErrorIconColor("transparent");
        setIsSelectFocused(true);
    };
    const onBlur = () => {
        setErrorIconColor(defaultErrorIconColor(colorScheme));
        setIsSelectFocused(false);
    };
    const onMouseOver = () => {
        if (!isSelectFocused) {
            setErrorIconColor(hoveredErrorIconColor());
        }
    };
    const onMouseOut = () => {
        if (!isSelectFocused) {
            setErrorIconColor(defaultErrorIconColor(colorScheme));
        }
    };
    return (_jsxs(FormControl, { ...formControlStyles, alignItems: "start", isInvalid: isInvalid, children: [label && _jsx(FormLabel, { fontWeight: "bold", children: label }), _jsx(InputGroup, { onFocus: onFocus, onBlur: onBlur, onMouseOver: onMouseOver, onMouseOut: onMouseOut, "data-testid": dataTestId, isolation: "unset", children: _jsx(ChakraSelect, { ...props, placeholder: placeholder, 
                    // @ts-ignore
                    chakraStyles: theme.components.getSelectStyles(), isSearchable: isSearchable, isDisabled: isDisabled, tagColorScheme: colorScheme, selectedOptionColorScheme: colorScheme, onChange: handleChange }) }), _jsx(FormErrorMessage, { colorScheme: colorScheme, children: errorMessage }), isInvalid && (_jsx(InputGroup, { children: _jsx(InputRightElement, { right: 6, top: "unset", bottom: "27px", pointerEvents: "none", children: _jsx(Info, { boxSize: 4, pointerEvents: "none", color: errorIconColor }) }) })), caption && !isInvalid && _jsx(FormHelperText, { children: caption })] }));
};
